import { render, staticRenderFns } from "./TokenAssignmentPanel.vue?vue&type=template&id=4d7f83bc"
import script from "./TokenAssignmentPanel.vue?vue&type=script&lang=js"
export * from "./TokenAssignmentPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports